


// // D:\MAHAL(UPDATED)-NEW11-04\MAHAL kdsagakhjqsdfk\src\pages\Support\SLAMonitor.js

// import React, { useEffect, useMemo, useState, useCallback } from "react";
// import axios from "axios";
// import {
//   ResponsiveContainer,
//   AreaChart,
//   Area,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   RadialBarChart,
//   RadialBar,
//   PieChart,
//   Pie,
//   Cell,
//   BarChart,
//   Bar,
//   Legend,
// } from "recharts";

// import {
//   FaTriangleExclamation,
//   FaRotateRight,
//   FaShieldHalved,
//   FaFireFlameCurved,
//   FaGaugeHigh,
//   FaBolt,
//   FaUserShield,
//   FaHourglassHalf,
//   FaArrowTrendUp,
//   FaCheck,
//   FaWaveSquare,
//   FaCircleExclamation,
//   FaBell,
//   FaServer,
//   FaSpinner,
//   FaLayerGroup,
//   FaChartLine,
//   FaChartPie,
//   FaRegCircleDot,
//   FaClock,
// } from "react-icons/fa6";

// // import "./SLAMonitor.css";
// import "./Support.css";

// /* =========================================================
//    API
// ========================================================= */

// const API = "https://api.mahal.qa/api/v1/admin/support";

// /* =========================================================
//    COLORS
// ========================================================= */

// const ORANGE_COLORS = [
//   "#fff1e6",
//   "#ffd8b5",
//   "#ffbf86",
//   "#ffa94d",
//   "#ff922b",
//   "#f77f00",
// ];

// const ORANGE_MAIN = "#f77f00";
// const ORANGE_DARK = "#d96a00";
// const ORANGE_LIGHT = "#fff4e8";

// /* =========================================================
//    HELPERS
// ========================================================= */

// function formatDateLabel(value) {
//   if (!value) return "-";
//   const date = new Date(value);
//   if (Number.isNaN(date.getTime())) return "-";
//   return date.toLocaleDateString(undefined, {
//     month: "short",
//     day: "numeric",
//   });
// }

// function formatDateTime(value) {
//   if (!value) return "-";
//   const date = new Date(value);
//   if (Number.isNaN(date.getTime())) return "-";
//   return date.toLocaleString();
// }

// function toNumber(value, fallback = 0) {
//   const num = Number(value);
//   return Number.isFinite(num) ? num : fallback;
// }

// function normalizePriority(priority) {
//   const value = String(priority || "normal").toLowerCase();
//   if (value === "high") return "high";
//   if (value === "low") return "low";
//   return "normal";
// }

// function getPriorityLabel(priority) {
//   const value = normalizePriority(priority);
//   if (value === "high") return "High";
//   if (value === "low") return "Low";
//   return "Normal";
// }

// function getStatusLabel(status) {
//   const value = String(status || "").toLowerCase();
//   if (!value) return "open";
//   return value;
// }

// function buildLast7Days() {
//   const days = [];
//   for (let i = 6; i >= 0; i -= 1) {
//     const d = new Date();
//     d.setHours(0, 0, 0, 0);
//     d.setDate(d.getDate() - i);
//     days.push({
//       key: d.toISOString().slice(0, 10),
//       label: d.toLocaleDateString(undefined, { weekday: "short" }),
//     });
//   }
//   return days;
// }

// function ChartTooltip({ active, payload, label }) {
//   if (!active || !payload || !payload.length) return null;

//   return (
//     <div className="sla_tooltip">
//       <div className="sla_tooltip_label">{label}</div>
//       <div className="sla_tooltip_rows">
//         {payload.map((item) => (
//           <div key={item.dataKey} className="sla_tooltip_row">
//             <span className="sla_tooltip_dot" style={{ background: item.color }} />
//             <span>{item.name || item.dataKey}</span>
//             <strong>{item.value}</strong>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// function StatCard({ title, value, icon, type, subtitle }) {
//   return (
//     <div className={`sla_summary_card ${type}`}>
//       <div className="sla_summary_icon">{icon}</div>
//       <div className="sla_summary_meta">
//         <h3>{value}</h3>
//         <p>{title}</p>
//         {subtitle ? <span>{subtitle}</span> : null}
//       </div>
//     </div>
//   );
// }

// function SectionHeader({ eyebrow, title, icon }) {
//   return (
//     <div className="sla_card_header">
//       <div className="sla_card_header_text">
//         <span>{eyebrow}</span>
//         <h3>{title}</h3>
//       </div>
//       <div className="sla_card_header_icon">{icon}</div>
//     </div>
//   );
// }

// /* =========================================================
//    COMPONENT
// ========================================================= */

// export default function SLAMonitor() {
//   const token = localStorage.getItem("admin_token");

//   const [loading, setLoading] = useState(true);
//   const [refreshing, setRefreshing] = useState(false);

//   const [tickets, setTickets] = useState([]);
//   const [slaBreached, setSlaBreached] = useState([]);
//   const [performance, setPerformance] = useState([]);
//   const [dashboard, setDashboard] = useState({});

//   /* =========================================================
//      FETCH
//   ========================================================= */

//   const fetchSLAData = useCallback(
//     async (showRefresh = false) => {
//       try {
//         if (showRefresh) {
//           setRefreshing(true);
//         } else {
//           setLoading(true);
//         }

//         const headers = token ? { Authorization: `Bearer ${token}` } : {};

//         const [ticketsRes, slaRes, performanceRes, dashboardRes] =
//           await Promise.all([
//             axios.get(`${API}/tickets`, {
//               headers,
//               params: { limit: 200 },
//             }),
//             axios.get(`${API}/sla-breached`, { headers }),
//             axios.get(`${API}/admin-performance`, { headers }),
//             axios.get(`${API}/dashboard`, { headers }),
//           ]);

//         setTickets(ticketsRes.data?.data || []);
//         setSlaBreached(slaRes.data || []);
//         setPerformance(performanceRes.data || []);
//         setDashboard(dashboardRes.data || {});
//       } catch (error) {
//         console.error("SLA Monitor failed", error);
//       } finally {
//         setLoading(false);
//         setRefreshing(false);
//       }
//     },
//     [token]
//   );

//   /* =========================================================
//      INITIAL LOAD
//   ========================================================= */

//   useEffect(() => {
//     fetchSLAData();

//     const interval = setInterval(() => {
//       fetchSLAData(true);
//     }, 20000);

//     return () => clearInterval(interval);
//   }, [fetchSLAData]);

//   /* =========================================================
//      ANALYTICS
//   ========================================================= */

//   const activeTickets = useMemo(
//     () =>
//       tickets.filter(
//         (ticket) => !["resolved", "closed"].includes(getStatusLabel(ticket.status))
//       ),
//     [tickets]
//   );

//   const safeTickets = useMemo(
//     () => activeTickets.filter((ticket) => !ticket.sla_breached),
//     [activeTickets]
//   );

//   const highRiskTickets = useMemo(
//     () =>
//       activeTickets.filter(
//         (ticket) => normalizePriority(ticket.priority) === "high" || toNumber(ticket.escalation_level, 0) > 0
//       ),
//     [activeTickets]
//   );

//   const slaHealthScore = useMemo(() => {
//     if (!activeTickets.length) return 100;
//     const score = ((activeTickets.length - slaBreached.length) / activeTickets.length) * 100;
//     return Math.max(0, Math.round(score));
//   }, [activeTickets.length, slaBreached.length]);

//   const healthTone =
//     slaHealthScore >= 80 ? "good" : slaHealthScore >= 50 ? "warning" : "danger";

//   const slaGaugeData = useMemo(
//     () => [
//       {
//         name: "Health",
//         value: slaHealthScore,
//         fill:
//           healthTone === "good"
//             ? ORANGE_MAIN
//             : healthTone === "warning"
//               ? "#ff922b"
//               : "#ffbf86",
//       },
//     ],
//     [slaHealthScore, healthTone]
//   );

//   const queueRiskData = useMemo(() => {
//     const grouped = {};

//     slaBreached.forEach((ticket) => {
//       const queue = ticket.queue_name || "Unknown";
//       grouped[queue] = (grouped[queue] || 0) + 1;
//     });

//     return Object.entries(grouped)
//       .map(([queue, breached]) => ({ queue, breached }))
//       .sort((a, b) => b.breached - a.breached)
//       .slice(0, 8);
//   }, [slaBreached]);

//   const priorityData = useMemo(() => {
//     const grouped = {
//       High: 0,
//       Normal: 0,
//       Low: 0,
//       Escalated: 0,
//     };

//     activeTickets.forEach((ticket) => {
//       const priority = normalizePriority(ticket.priority);

//       if (priority === "high") grouped.High += 1;
//       if (priority === "normal") grouped.Normal += 1;
//       if (priority === "low") grouped.Low += 1;
//       if (toNumber(ticket.escalation_level, 0) > 0) grouped.Escalated += 1;
//     });

//     return Object.entries(grouped).map(([name, value]) => ({ name, value }));
//   }, [activeTickets]);

//   const slaTrend = useMemo(() => {
//     const days = buildLast7Days();
//     const grouped = {};

//     days.forEach(({ key, label }) => {
//       grouped[key] = {
//         day: label,
//         breaches: 0,
//         tickets: 0,
//       };
//     });

//     tickets.forEach((ticket) => {
//       const created = new Date(ticket.created_at);
//       if (Number.isNaN(created.getTime())) return;

//       const key = created.toISOString().slice(0, 10);
//       if (!grouped[key]) return;

//       grouped[key].tickets += 1;
//       if (ticket.sla_breached) grouped[key].breaches += 1;
//     });

//     return days.map(({ key }) => grouped[key]);
//   }, [tickets]);

//   const topRiskAdmins = useMemo(
//     () =>
//       [...performance]
//         .sort((a, b) => (toNumber(b.sla_breached_open, 0) || 0) - (toNumber(a.sla_breached_open, 0) || 0))
//         .slice(0, 6),
//     [performance]
//   );

//   const recentBreaches = useMemo(
//     () =>
//       [...slaBreached]
//         .sort((a, b) => new Date(b.sla_due_at || 0) - new Date(a.sla_due_at || 0))
//         .slice(0, 8),
//     [slaBreached]
//   );

//   const summaryCards = [
//     {
//       title: "SLA Breaches",
//       value: slaBreached.length,
//       icon: <FaTriangleExclamation />,
//       type: "danger",
//       subtitle: "Tickets past SLA",
//     },
//     {
//       title: "Healthy Tickets",
//       value: safeTickets.length,
//       icon: <FaShieldHalved />,
//       type: "success",
//       subtitle: "Within SLA limits",
//     },
//     {
//       title: "Critical Risk",
//       value: highRiskTickets.length,
//       icon: <FaFireFlameCurved />,
//       type: "critical",
//       subtitle: "High-priority or escalated",
//     },
//     {
//       title: "SLA Health",
//       value: `${slaHealthScore}%`,
//       icon: <FaGaugeHigh />,
//       type: healthTone,
//       subtitle: "Current stability index",
//     },
//     {
//       title: "Open Tickets",
//       value: dashboard.open || 0,
//       icon: <FaLayerGroup />,
//       type: "neutral",
//       subtitle: "Still in progress",
//     },
//     {
//       title: "Monitoring",
//       value: activeTickets.length,
//       icon: <FaWaveSquare />,
//       type: "warning",
//       subtitle: "Tickets under watch",
//     },
//   ];

//   /* =========================================================
//      LOADING
//   ========================================================= */

//   if (loading) {
//     return (
//       <div className="sla_loader_screen">
//         <div className="sla_loader_box">
//           <FaSpinner className="sla_loader_icon" />
//           <h2>Initializing SLA Grid</h2>
//           <p>Connecting enterprise monitoring systems...</p>
//         </div>
//       </div>
//     );
//   }

//   /* =========================================================
//      RENDER
//   ========================================================= */

//   return (
//     <div className="support-page">
//       <div className="support-header">
//         <div className="support-header-content">
//           <div className="support-live-tag">
//             <span className="support-live-dot" />
//             LIVE SLA MONITORING
//           </div>

//           <h1>Enterprise SLA Command Center</h1>
//           <p>Real-time operational breach detection and response analytics</p>
//         </div>

//         <button
//           className={`support-refresh-btn ${refreshing ? "support-refreshing" : ""
//             }`}
            
//           onClick={() => fetchSLAData(true)}
//           type="button"
//           disabled={refreshing}
//         >
//           <FaRotateRight />
//           {/* <span>{refreshing ? "Refreshing" : "Refresh"}</span> */}
//         </button>
//       </div>

//       <div className="sla_hero_grid">
//         <div className="sla_health_panel">
//           <SectionHeader
//             eyebrow="System Health"
//             title="SLA Stability Index"
//             icon={<FaServer />}
//           />

//           <div className="sla_gauge_wrapper">
//             <ResponsiveContainer width="100%" height={260}>
//               <RadialBarChart
//                 cx="50%"
//                 cy="50%"
//                 innerRadius="72%"
//                 outerRadius="100%"
//                 barSize={18}
//                 data={slaGaugeData}
//                 startAngle={180}
//                 endAngle={0}
//               >
//                 <RadialBar background dataKey="value" cornerRadius={999} />
//                 <text
//                   x="50%"
//                   y="48%"
//                   textAnchor="middle"
//                   dominantBaseline="middle"
//                   className="sla_gauge_text"
//                 >
//                   {slaHealthScore}%
//                 </text>
//               </RadialBarChart>
//             </ResponsiveContainer>
//           </div>

//           <div className="sla_health_footer">
//             <div>
//               <FaCheck />
//               <span>Stable Tickets</span>
//               <strong>{safeTickets.length}</strong>
//             </div>

//             <div>
//               <FaCircleExclamation />
//               <span>Active Risks</span>
//               <strong>{slaBreached.length}</strong>
//             </div>
//           </div>
//         </div>

//         <div className="sla_summary_grid">
//           {summaryCards.map((card, index) => (
//             <StatCard
//               key={index}
//               title={card.title}
//               value={card.value}
//               icon={card.icon}
//               type={card.type}
//               subtitle={card.subtitle}
//             />
//           ))}
//         </div>
//       </div>

//       <div className="sla_chart_grid">
//         <div className="sla_card sla_large_card">
//           <SectionHeader
//             eyebrow="SLA Traffic"
//             title="Breach Detection Timeline"
//             icon={<FaArrowTrendUp />}
//           />

//           <ResponsiveContainer width="100%" height={340}>
//             <AreaChart data={slaTrend}>
//               <defs>
//                 <linearGradient id="slaArea" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="5%" stopColor={ORANGE_MAIN} stopOpacity={0.35} />
//                   <stop offset="95%" stopColor={ORANGE_MAIN} stopOpacity={0} />
//                 </linearGradient>
//               </defs>

//               <CartesianGrid strokeDasharray="3 3" stroke="#ececec" />
//               <XAxis
//                 dataKey="day"
//                 tick={{ fill: "#111827", fontSize: 12 }}
//                 axisLine={false}
//                 tickLine={false}
//               />
//               <YAxis
//                 tick={{ fill: "#111827", fontSize: 12 }}
//                 axisLine={false}
//                 tickLine={false}
//                 allowDecimals={false}
//               />
//               <Tooltip content={<ChartTooltip />} />
//               <Area
//                 type="monotone"
//                 dataKey="breaches"
//                 name="Breaches"
//                 stroke={ORANGE_MAIN}
//                 strokeWidth={3}
//                 fillOpacity={1}
//                 fill="url(#slaArea)"
//               />
//             </AreaChart>
//           </ResponsiveContainer>
//         </div>

//         <div className="sla_card">
//           <SectionHeader
//             eyebrow="Risk Matrix"
//             title="Ticket Risk Split"
//             icon={<FaChartPie />}
//           />

//           <div className="sla_donut_wrap">
//             <div className="sla_donut_center">
//               <span>Health</span>
//               <strong>{slaHealthScore}%</strong>
//               <p>Stability index</p>
//             </div>

//             <ResponsiveContainer width="100%" height={340}>
//               <PieChart>
//                 <Pie
//                   data={priorityData}
//                   dataKey="value"
//                   nameKey="name"
//                   innerRadius={78}
//                   outerRadius={118}
//                   paddingAngle={4}
//                   cornerRadius={8}
//                   stroke="#ffffff"
//                   strokeWidth={3}
//                   labelLine={false}
//                 >
//                   {priorityData.map((entry, index) => (
//                     <Cell key={entry.name} fill={ORANGE_COLORS[index % ORANGE_COLORS.length]} />
//                   ))}
//                 </Pie>

//                 <Tooltip content={<ChartTooltip />} />
//                 <Legend
//                   verticalAlign="bottom"
//                   align="center"
//                   iconType="circle"
//                   wrapperStyle={{ paddingTop: 12, color: "#111827" }}
//                 />
//               </PieChart>
//             </ResponsiveContainer>
//           </div>

//           <div className="sla_mini_stats">
//             {priorityData.map((item) => (
//               <div key={item.name} className="sla_mini_stat">
//                 <span>{item.name}</span>
//                 <strong>{item.value}</strong>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div className="sla_chart_grid">
//         <div className="sla_card">
//           <SectionHeader
//             eyebrow="Queue Pressure"
//             title="Breach Distribution"
//             icon={<FaLayerGroup />}
//           />

//           <ResponsiveContainer width="100%" height={340}>
//             <BarChart data={queueRiskData}>
//               <defs>
//                 <linearGradient id="slaBarOrange" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#ffbf86" />
//                   <stop offset="100%" stopColor={ORANGE_MAIN} />
//                 </linearGradient>
//               </defs>

//               <CartesianGrid strokeDasharray="3 3" stroke="#ececec" />
//               <XAxis
//                 dataKey="queue"
//                 tick={{ fill: "#111827", fontSize: 12 }}
//                 axisLine={false}
//                 tickLine={false}
//               />
//               <YAxis
//                 tick={{ fill: "#111827", fontSize: 12 }}
//                 axisLine={false}
//                 tickLine={false}
//                 allowDecimals={false}
//               />
//               <Tooltip content={<ChartTooltip />} />
//               <Bar
//                 dataKey="breached"
//                 name="Breached"
//                 fill="url(#slaBarOrange)"
//                 radius={[10, 10, 0, 0]}
//               />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>

//         <div className="sla_card">
//           <SectionHeader
//             eyebrow="Admin Load"
//             title="SLA Risk Operators"
//             icon={<FaUserShield />}
//           />

//           <div className="sla_admin_list">
//             {topRiskAdmins.length === 0 && (
//               <div className="sla_empty">No admin performance data</div>
//             )}

//             {topRiskAdmins.map((admin, index) => (
//               <div key={index} className="sla_admin_row">
//                 <div className="sla_admin_left">
//                   <div className="sla_admin_avatar">
//                     <FaUserShield />
//                   </div>

//                   <div>
//                     <h4>{admin.name}</h4>
//                     <p>{admin.queue_name || "Support Queue"}</p>
//                   </div>
//                 </div>

//                 <div className="sla_admin_right">
//                   <div className="sla_admin_metric danger">
//                     <FaTriangleExclamation />
//                     {admin.sla_breached_open || 0}
//                   </div>

//                   <div className="sla_admin_metric info">
//                     <FaHourglassHalf />
//                     {Number(admin.avg_resolution_hours || 0).toFixed(1)}h
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div className="sla_card">
//         <SectionHeader
//           eyebrow="Live Incidents"
//           title="Active SLA Violations"
//           icon={<FaBell />}
//         />

//         <div className="sla_table_wrapper">
//           <table className="sla_table">
//             <thead>
//               <tr>
//                 <th>Ticket</th>
//                 <th>Priority</th>
//                 <th>Status</th>
//                 <th>Escalation</th>
//                 <th>Admin</th>
//                 <th>SLA Due</th>
//               </tr>
//             </thead>

//             <tbody>
//               {recentBreaches.map((ticket) => (
//                 <tr key={ticket.ticket_id}>
//                   <td>
//                     <div className="sla_ticket_info">
//                       <strong>#{ticket.ticket_id}</strong>
//                       <span>{ticket.subject}</span>
//                     </div>
//                   </td>

//                   <td>
//                     <span className={`sla_priority ${normalizePriority(ticket.priority)}`}>
//                       {getPriorityLabel(ticket.priority)}
//                     </span>
//                   </td>

//                   <td>
//                     <span className="sla_status_live">{getStatusLabel(ticket.status)}</span>
//                   </td>

//                   <td>
//                     <span className="sla_escalation">Level {toNumber(ticket.escalation_level, 0)}</span>
//                   </td>

//                   <td>{ticket.assigned_admin_name || "Unassigned"}</td>

//                   <td>{formatDateTime(ticket.sla_due_at)}</td>
//                 </tr>
//               ))}

//               {recentBreaches.length === 0 && (
//                 <tr>
//                   <td colSpan={6}>
//                     <div className="sla_empty">No SLA breaches found</div>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }



import React, {
  useEffect,
  useMemo,
  useState,
  useCallback
} from "react";

import axios from "axios";

import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  RadialBarChart,
  RadialBar,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar
} from "recharts";

import {
  FaTriangleExclamation,
  FaRotateRight,
  FaShieldHalved,
  FaFireFlameCurved,
  FaGaugeHigh,
  FaCheck,
  FaCircleExclamation,
  FaBell,
  FaServer,
  FaSpinner,
  FaLayerGroup,
  FaChartLine,
  FaChartPie,
  FaUserShield,
  FaHourglassHalf,
  FaWaveSquare
} from "react-icons/fa6";

// import "./SLAMonitor.css";
import "./Support.css";

/* =========================================================
   API
========================================================= */

const API = "https://api.mahal.qa/api/v1/admin/support";

/* =========================================================
   COLORS
========================================================= */

const ORANGE_COLORS = [
  "#fff1e6",
  "#ffd8b5",
  "#ffbf86",
  "#ffa94d",
  "#ff922b",
  "#f77f00"
];

const ORANGE_MAIN = "#f77f00";

/* =========================================================
   HELPERS
========================================================= */

function formatDateTime(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString();
}

function toNumber(value, fallback = 0) {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
}

function toTimestamp(value) {
  const ts = new Date(value).getTime();
  return Number.isFinite(ts) ? ts : 0;
}

function normalizePriority(priority) {
  const value = String(priority || "normal").toLowerCase();
  if (value === "high") return "high";
  if (value === "low") return "low";
  return "normal";
}

function getPriorityLabel(priority) {
  const value = normalizePriority(priority);
  if (value === "high") return "High";
  if (value === "low") return "Low";
  return "Normal";
}

function getStatusLabel(status) {
  const value = String(status || "").toLowerCase();
  if (!value) return "open";
  return value;
}

function buildLast7Days() {
  const days = [];

  for (let i = 6; i >= 0; i -= 1) {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() - i);

    days.push({
      key: d.toISOString().slice(0, 10),
      label: d.toLocaleDateString(undefined, {
        weekday: "short"
      })
    });
  }

  return days;
}

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;

  return (
    <div className="support-tooltip">
      <div className="support-tooltip-label">{label}</div>

      <div>
        {payload.map((item) => (
          <div key={item.dataKey} className="support-tooltip-row">
            <span
              className="support-tooltip-dot"
              style={{ background: item.color }}
            />
            <span>{item.name || item.dataKey}</span>
            <strong>{item.value}</strong>
          </div>
        ))}
      </div>
    </div>
  );
}

/* =========================================================
   COMPONENT
========================================================= */

export default function SLAMonitor() {
  const token = localStorage.getItem("admin_token");

  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const [tickets, setTickets] = useState([]);
  const [slaBreached, setSlaBreached] = useState([]);
  const [performance, setPerformance] = useState([]);
  const [dashboard, setDashboard] = useState({});

  /* =========================================================
     FETCH
  ========================================================= */

  const fetchSLAData = useCallback(
    async (showRefresh = false) => {
      try {
        if (showRefresh) {
          setRefreshing(true);
        } else {
          setLoading(true);
        }

        const headers = token
          ? { Authorization: `Bearer ${token}` }
          : {};

        const [
          ticketsRes,
          slaRes,
          performanceRes,
          dashboardRes
        ] = await Promise.all([
          axios.get(`${API}/tickets`, {
            headers,
            params: { limit: 200 }
          }),
          axios.get(`${API}/sla-breached`, { headers }),
          axios.get(`${API}/admin-performance`, { headers }),
          axios.get(`${API}/dashboard`, { headers })
        ]);

        setTickets(ticketsRes.data?.data || []);
        setSlaBreached(slaRes.data || []);
        setPerformance(performanceRes.data || []);
        setDashboard(dashboardRes.data || {});
      } catch (error) {
        console.error("SLA Monitor failed", error);
      } finally {
        setLoading(false);
        setRefreshing(false);
      }
    },
    [token]
  );

  useEffect(() => {
    fetchSLAData();

    const interval = setInterval(() => {
      fetchSLAData(true);
    }, 20000);

    return () => clearInterval(interval);
  }, [fetchSLAData]);

  /* =========================================================
     ANALYTICS
  ========================================================= */

  const activeTickets = useMemo(
    () =>
      tickets.filter(
        (ticket) =>
          !["resolved", "closed"].includes(
            getStatusLabel(ticket.status)
          )
      ),
    [tickets]
  );

  const safeTickets = useMemo(
    () => activeTickets.filter((ticket) => !ticket.sla_breached),
    [activeTickets]
  );

  const highRiskTickets = useMemo(
    () =>
      activeTickets.filter(
        (ticket) =>
          normalizePriority(ticket.priority) === "high" ||
          toNumber(ticket.escalation_level, 0) > 0
      ),
    [activeTickets]
  );

  const slaHealthScore = useMemo(() => {
    if (!activeTickets.length) return 100;
    const score =
      ((activeTickets.length - slaBreached.length) /
        activeTickets.length) *
      100;
    return Math.max(0, Math.round(score));
  }, [activeTickets.length, slaBreached.length]);

  const healthTone =
    slaHealthScore >= 80
      ? "success"
      : slaHealthScore >= 50
      ? "warning"
      : "danger";

  const gaugeData = useMemo(
    () => [
      {
        name: "Health",
        value: slaHealthScore,
        fill:
          healthTone === "success"
            ? ORANGE_MAIN
            : healthTone === "warning"
            ? "#ff922b"
            : "#ffbf86"
      }
    ],
    [slaHealthScore, healthTone]
  );

  const queueRiskData = useMemo(() => {
    const grouped = {};

    slaBreached.forEach((ticket) => {
      const queue = ticket.queue_name || "Unknown";
      grouped[queue] = (grouped[queue] || 0) + 1;
    });

    return Object.entries(grouped)
      .map(([queue, breached]) => ({
        queue,
        breached
      }))
      .sort((a, b) => b.breached - a.breached)
      .slice(0, 8);
  }, [slaBreached]);

  const priorityData = useMemo(() => {
    const grouped = {
      High: 0,
      Normal: 0,
      Low: 0,
      Escalated: 0
    };

    activeTickets.forEach((ticket) => {
      const priority = normalizePriority(ticket.priority);

      if (priority === "high") grouped.High += 1;
      if (priority === "normal") grouped.Normal += 1;
      if (priority === "low") grouped.Low += 1;
      if (toNumber(ticket.escalation_level, 0) > 0) grouped.Escalated += 1;
    });

    return Object.entries(grouped).map(([name, value]) => ({
      name,
      value
    }));
  }, [activeTickets]);

  const slaTrend = useMemo(() => {
    const days = buildLast7Days();
    const grouped = {};

    days.forEach(({ key, label }) => {
      grouped[key] = {
        day: label,
        breaches: 0,
        tickets: 0
      };
    });

    tickets.forEach((ticket) => {
      const created = new Date(ticket.created_at);
      if (Number.isNaN(created.getTime())) return;

      const key = created.toISOString().slice(0, 10);
      if (!grouped[key]) return;

      grouped[key].tickets += 1;
      if (ticket.sla_breached) grouped[key].breaches += 1;
    });

    return days.map(({ key }) => grouped[key]);
  }, [tickets]);

  const topRiskAdmins = useMemo(
    () =>
      [...performance]
        .sort(
          (a, b) =>
            toNumber(b.sla_breached_open, 0) -
            toNumber(a.sla_breached_open, 0)
        )
        .slice(0, 6),
    [performance]
  );

  const recentBreaches = useMemo(
    () =>
      [...slaBreached]
        .sort(
          (a, b) =>
            toTimestamp(b.sla_due_at) - toTimestamp(a.sla_due_at)
        )
        .slice(0, 8),
    [slaBreached]
  );

  const summaryCards = useMemo(
    () => [
      {
        title: "SLA Breaches",
        value: slaBreached.length,
        icon: <FaTriangleExclamation />,
        className: "danger",
        subtitle: "Tickets past SLA"
      },
      {
        title: "Healthy Tickets",
        value: safeTickets.length,
        icon: <FaShieldHalved />,
        className: "danger",
        subtitle: "Within SLA limits"
      },
      {
        title: "Critical Risk",
        value: highRiskTickets.length,
        icon: <FaFireFlameCurved />,
        className: "critical",
        subtitle: "High priority or escalated"
      },
      {
        title: "SLA Health",
        value: `${slaHealthScore}%`,
        icon: <FaGaugeHigh />,
        className: healthTone,
        subtitle: "Current stability index"
      },
      {
        title: "Open Tickets",
        value: dashboard.open || 0,
        icon: <FaLayerGroup />,
        className: "info",
        subtitle: "Still in progress"
      },
      {
        title: "Monitoring",
        value: activeTickets.length,
        icon: <FaWaveSquare />,
        className: "warning",
        subtitle: "Tickets under watch"
      }
    ],
    [
      activeTickets.length,
      dashboard.open,
      healthTone,
      highRiskTickets.length,
      safeTickets.length,
      slaBreached.length,
      slaHealthScore
    ]
  );

  /* =========================================================
     LOADING
  ========================================================= */

  if (loading) {
    return (
      <div className="support-loader">
        <div className="support-loader-card">
          <div className="support-loader-ring" />
          <h2>Initializing SLA Grid</h2>
          <p>Connecting enterprise monitoring systems...</p>
        </div>
      </div>
    );
  }

  /* =========================================================
     RENDER
  ========================================================= */

  return (
    <div className="support-page">
      {/* ====================================================
         HEADER
      ==================================================== */}

      <div className="support-header">
        <div className="support-header-content">
          <div className="support-live-tag">
            <span className="support-live-dot" />
            LIVE SLA MONITORING
          </div>

          <h1>Enterprise SLA Command Center</h1>
          <p>Real-time operational breach detection and response analytics</p>
        </div>

        <button
          className={`support-refresh-btn ${
            refreshing ? "support-refreshing" : ""
          }`}
          onClick={() => fetchSLAData(true)}
          type="button"
          disabled={refreshing}
        >
          <FaRotateRight />
          {/* <span>{refreshing ? "Refreshing" : "Refresh"}</span> */}
        </button>
      </div>

      {/* ====================================================
         SUMMARY CARDS
      ==================================================== */}

      <div className="support-summary-grid">
        {summaryCards.map((card, index) => (
          <div
            key={index}
            className={`support-summary-card ${card.className}`}
          >
            <div className="support-summary-icon">{card.icon}</div>

            <div className="support-summary-meta">
              <h3>{card.value}</h3>
              <p>{card.title}</p>
              <span>{card.subtitle}</span>
            </div>
          </div>
        ))}
      </div>

      {/* ====================================================
         TOP CHART GRID
      ==================================================== */}

      <div className="support-chart-grid">
        {/* ================================================
           SLA HEALTH
        ================================================ */}

        <div className="support-panel support-panel--accent">
          <div className="support-panel-header">
            <div className="support-panel-title">
              <span>System Health</span>
              <h3>SLA Stability Index</h3>
            </div>

            <div className="support-panel-icon">
              <FaServer />
            </div>
          </div>

          <div className="support-donut-wrap">
            <div className="support-donut-center">
              <span>Health</span>
              <strong>{slaHealthScore}%</strong>
              <p>Stability index</p>
            </div>

            <ResponsiveContainer width="100%" height={260}>
              <RadialBarChart
                cx="50%"
                cy="50%"
                innerRadius="72%"
                outerRadius="100%"
                barSize={18}
                data={gaugeData}
                startAngle={180}
                endAngle={0}
              >
                <RadialBar
                  background
                  dataKey="value"
                  cornerRadius={999}
                />
              </RadialBarChart>
            </ResponsiveContainer>
          </div>

          <div className="support-health-progress">
            <div
              className="support-health-fill"
              style={{
                width: `${slaHealthScore}%`
              }}
            />
          </div>

          <div className="support-health-metrics">
            <div>
              <strong>{activeTickets.length}</strong>
              <p>Active Tickets</p>
            </div>

            <div>
              <strong>{safeTickets.length}</strong>
              <p>Safe Tickets</p>
            </div>

            <div>
              <strong>{highRiskTickets.length}</strong>
              <p>High Risk</p>
            </div>
          </div>
        </div>

        {/* ================================================
           TREND
        ================================================ */}

        <div className="support-panel">
          <div className="support-panel-header">
            <div className="support-panel-title">
              <span>SLA TRAFFIC</span>
              <h3>Breach Detection Timeline</h3>
            </div>

            <div className="support-panel-icon">
              <FaChartLine />
            </div>
          </div>

          <ResponsiveContainer width="100%" height={340}>
            <AreaChart data={slaTrend}>
              <defs>
                <linearGradient id="supportSlaArea" x1="0" y1="0" x2="0" y2="1">
                  <stop
                    offset="5%"
                    stopColor={ORANGE_MAIN}
                    stopOpacity={0.35}
                  />
                  <stop
                    offset="95%"
                    stopColor={ORANGE_MAIN}
                    stopOpacity={0}
                  />
                </linearGradient>
              </defs>

              <CartesianGrid strokeDasharray="3 3" stroke="#ececec" />
              <XAxis
                dataKey="day"
                tick={{ fill: "#111827", fontSize: 12 }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                tick={{ fill: "#111827", fontSize: 12 }}
                axisLine={false}
                tickLine={false}
                allowDecimals={false}
              />
              <Tooltip content={<ChartTooltip />} />
              <Area
                type="monotone"
                dataKey="breaches"
                name="Breaches"
                stroke={ORANGE_MAIN}
                strokeWidth={3}
                fillOpacity={1}
                fill="url(#supportSlaArea)"
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* ====================================================
         SECOND ROW
      ==================================================== */}

      <div className="support-two-col-grid">
        {/* ================================================
           RISK SPLIT
        ================================================ */}

        <div className="support-panel support-panel--soft">
          <div className="support-panel-header">
            <div className="support-panel-title">
              <span>Risk Matrix</span>
              <h3>Ticket Risk Split</h3>
            </div>

            <div className="support-panel-icon">
              <FaChartPie />
            </div>
          </div>

          <div className="support-donut-wrap">
            <div className="support-donut-center">
              <span>Risk</span>
              <strong>{highRiskTickets.length}</strong>
              <p>High risk tickets</p>
            </div>

            <ResponsiveContainer width="100%" height={340}>
              <PieChart>
                <Pie
                  data={priorityData}
                  dataKey="value"
                  nameKey="name"
                  innerRadius={78}
                  outerRadius={118}
                  paddingAngle={4}
                  cornerRadius={8}
                  stroke="#ffffff"
                  strokeWidth={3}
                  labelLine={false}
                >
                  {priorityData.map((entry, index) => (
                    <Cell
                      key={entry.name}
                      fill={ORANGE_COLORS[index % ORANGE_COLORS.length]}
                    />
                  ))}
                </Pie>

                <Tooltip content={<ChartTooltip />} />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="support-chart-legend">
            {priorityData.map((item, index) => (
              <div key={item.name} className="support-legend-item">
                <span
                  className="support-legend-dot"
                  style={{
                    background: ORANGE_COLORS[index % ORANGE_COLORS.length]
                  }}
                />
                {item.name}
                <strong>{item.value}</strong>
              </div>
            ))}
          </div>
        </div>

        {/* ================================================
           QUEUE LOAD
        ================================================ */}

        <div className="support-panel">
          <div className="support-panel-header">
            <div className="support-panel-title">
              <span>Queue Pressure</span>
              <h3>Breach Distribution</h3>
            </div>

            <div className="support-panel-icon">
              <FaLayerGroup />
            </div>
          </div>

          <ResponsiveContainer width="100%" height={340}>
            <BarChart data={queueRiskData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#ececec" />
              <XAxis
                dataKey="queue"
                tick={{ fill: "#111827", fontSize: 12 }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                tick={{ fill: "#111827", fontSize: 12 }}
                axisLine={false}
                tickLine={false}
                allowDecimals={false}
              />
              <Tooltip content={<ChartTooltip />} />
              <Bar
                dataKey="breached"
                name="Breached"
                fill="#df962a"
                radius={[10, 10, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* ====================================================
         TOP ADMINS
      ==================================================== */}

      <div className="support-panel">
        <div className="support-panel-header">
          <div className="support-panel-title">
            <span>Admin Load</span>
            <h3>SLA Risk Operators</h3>
          </div>

          <div className="support-panel-icon">
            <FaUserShield />
          </div>
        </div>

        <div className="support-top-list">
          {topRiskAdmins.length === 0 && (
            <div className="support-empty-state">
              No admin performance data
            </div>
          )}

          {topRiskAdmins.map((admin, index) => (
            <div key={index} className="support-top-row">
              <div className="support-user-info">
                <div className="support-avatar">
                  <FaUserShield />
                </div>

                <div>
                  <h4>{admin.name}</h4>
                  <p>{admin.queue_name || "Support Queue"}</p>
                </div>
              </div>

              <div className="support-admin-metrics">
                <div className="support-kpi-pill">
                  <FaCircleExclamation />
                  {admin.sla_breached_open || 0}
                </div>

                <div className="support-kpi-pill">
                  <FaHourglassHalf />
                  {Number(admin.avg_resolution_hours || 0).toFixed(1)}h
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ====================================================
         LIVE INCIDENTS
      ==================================================== */}

      <div className="support-panel">
        <div className="support-panel-header">
          <div className="support-panel-title">
            <span>Live Incidents</span>
            <h3>Active SLA Violations</h3>
          </div>

          <div className="support-panel-icon">
            <FaBell />
          </div>
        </div>

        <div className="support-table-wrap">
          <table className="support-table">
            <thead>
              <tr>
                <th>Ticket</th>
                <th>Priority</th>
                <th>Status</th>
                <th>Escalation</th>
                <th>Admin</th>
                <th>SLA Due</th>
              </tr>
            </thead>

            <tbody>
              {recentBreaches.map((ticket) => (
                <tr key={ticket.ticket_id}>
                  <td>
                    <div className="support-table-title">
                      <strong>#{ticket.ticket_id}</strong>
                      <span>{ticket.subject}</span>
                    </div>
                  </td>

                  <td>
                    <span
                      className={`support-priority ${normalizePriority(
                        ticket.priority
                      )}`}
                    >
                      {getPriorityLabel(ticket.priority)}
                    </span>
                  </td>

                  <td>
                    <span
                      className={`support-status is-${getStatusLabel(
                        ticket.status
                      )}`}
                    >
                      {getStatusLabel(ticket.status)}
                    </span>
                  </td>

                  <td>
                    <span className="support-badge is-critical">
                      Level {toNumber(ticket.escalation_level, 0)}
                    </span>
                  </td>

                  <td>{ticket.assigned_admin_name || "Unassigned"}</td>

                  <td>{formatDateTime(ticket.sla_due_at)}</td>
                </tr>
              ))}

              {recentBreaches.length === 0 && (
                <tr>
                  <td colSpan={6}>
                    <div className="support-empty-state">
                      No SLA breaches found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}